import { gql } from '@apollo/client';

export default gql`
  mutation resetPassword($username: String!, $email: String!) {
    resetPassword(username: $username, email: $email)
  }
`;
